import {
  Component,
  HostBinding,
  OnInit,
  ViewEncapsulation,
} from '@angular/core';
import { SessionService } from '../../../common-shared/session';
import { appRoutes } from '../../config';
import { Router } from '@angular/router';
import { MsalService } from '@azure/msal-angular';
import { isFieldValueValid } from '../../../common-shared/forms/utils/is-field-value-valid';
import { validatorsConfig } from '../../config/validators';
import { ApiRequestBuilder, ApiService } from '../../../common-shared/api';
import { getRandomInt } from '../../../common-shared/utils';
import { TranslateService } from '@ngx-translate/core';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'login',
  templateUrl: './login.component.html',
  standalone: false,
  encapsulation: ViewEncapsulation.None,
})
export class LoginComponent implements OnInit {
  @HostBinding('class')
  readonly cssClass = 'login  page-container bg-no-repeat bg-cover';

  /*readonly cssClass =
    "login  page-container bg-no-repeat bg-cover bg-[url('/assets/images/login-background.jpg')]";*/

  email = '';
  password = '';
  code = '';

  sendingRequest = false;
  errorMessage = '';
  successMessage = '';

  formMode = 'LOGIN'; // 'LOGIN' | 'FORGOT' | 'RESET'
  showEmail = environment.showEmailLogin;

  constructor(
    private sessionService: SessionService,
    private apiService: ApiService,
    private router: Router,
    private authService: MsalService,
    private translateService: TranslateService,
  ) {}

  ngOnInit() {}

  isEmailValid(): boolean {
    return isFieldValueValid(this.email, true, validatorsConfig['email'].value);
  }

  async resetPassword(): Promise<void> {
    if (!this.isEmailValid() || this.sendingRequest) {
      return;
    }

    this.errorMessage = '';
    this.sendingRequest = true;
    const forgotRequest = new ApiRequestBuilder('resetPassword')
      //.setRecaptchaCode(this.recaptchaResponse)
      .setBody({ email: this.email, password: this.password, code: this.code })
      .build();

    const resultForgot = await this.apiService.callApi(forgotRequest);
    this.sendingRequest = false;
    if (!resultForgot || resultForgot.status === 'error') {
      this.errorMessage = this.translateService.instant(
        'login.resetPassword.error',
      );
    } else {
      this.successMessage = this.translateService.instant(
        'login.resetPassword.success',
      );
      this.formMode = 'LOGIN';
    }
    this.sendingRequest = false;
  }

  async requestPasswordReset(): Promise<void> {
    if (!this.isEmailValid() || this.sendingRequest) {
      return;
    }

    this.errorMessage = '';
    this.sendingRequest = true;
    const forgotRequest = new ApiRequestBuilder('forgotPassword')
      //.setRecaptchaCode(this.recaptchaResponse)
      .setBody({ email: this.email })
      .build();

    const resultForgot = await this.apiService.callApi(forgotRequest);
    this.sendingRequest = false;
    if (!resultForgot || resultForgot.status === 'error') {
      this.errorMessage = this.translateService.instant(
        'login.requestPasswordReset.error',
      );
    } else {
      this.successMessage = this.translateService.instant(
        'login.requestPasswordReset.success',
      );
      this.formMode = 'RESET';
    }
    this.sendingRequest = false;
  }
  async sendLogin(): Promise<void> {
    if (!this.isEmailValid()) {
      return;
    }
    console.log(this.email);
    console.log(this.password);

    this.errorMessage = '';
    this.sendingRequest = true;
    this.errorMessage = await this.sessionService.loginUser(
      this.email,
      this.password,
      true,
      undefined /*this.recaptchaResponse*/,
      undefined /*payload.code2FA*/,
    );
    this.sendingRequest = false;
    if (!this.errorMessage) {
      this.router.navigate([appRoutes['dashboard']]);
    }
  }

  isMsalLoginDisabled(): boolean {
    return this.sessionService.isLoggingAlreadyUserMsal();
  }
  async goToMsalLogin(): Promise<void> {
    if (this.isMsalLoginDisabled()) {
      return;
    }

    console.log('goToMsalLogin');
    /// this.router.navigate([appRoutes['loginMsal']]);

    this.authService
      .acquireTokenPopup({
        authority: `https://login.microsoftonline.com/common`,
        //redirectUri: 'http://localhost:4200',
        scopes: ['user.read', 'user.read.all'],
      })
      .subscribe(async (payload) => {
        console.log(payload);
        if (!this.sessionService.isLoggingAlreadyUserMsal()) {
          this.authService.instance.setActiveAccount(payload.account);
          const errorMessage = await this.sessionService.loginUserMsal(
            this.authService?.instance?.getAllAccounts()?.[0]?.idToken,
            this.authService?.instance?.getAllAccounts()?.[0]?.idTokenClaims
              ?.exp,
          );
          if (!errorMessage) {
            this.router.navigate([appRoutes['dashboard']]);
          }
        }
      });
  }
}
